export const EXPERT_LANGUAGES_LEVEL = {
    Unspecified: 0,
    Basic: 1,
    Conversational: 2,
    Fluent: 3,
    Native: 4,
};
